import axios from 'axios'

export async function updateReservation(values, usersLanguageISOCode) {
  const configs = {
    headers: {
      'Accept-Language': usersLanguageISOCode
    }
  };
  const res = await axios.post('/reservation-check-in', values, configs);
  return res.data;
}

export const reservationUpdateNotify = async () => {
  return (await axios.post(`/reservation-check-in-notify`)).data
}

export async function updateReservationDriverInfo(values, usersLanguageISOCode) {
  const configs = {
    headers: {
      'Accept-Language': usersLanguageISOCode
    }
  };
  const res = await axios.post('/reservation-update', values, configs);
  return res.data;
}

export const validateSessionCheckIn = async () => {
  return (await axios.get(`/reservation-check-in-validate`)).data
}